
define('template!ordersDetailOrderProductAlternativesView', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape;
with (obj) {
__p += '<div class="header">\n    <div class="title">' +
((__t = ( _.i18n('product.alternatives') )) == null ? '' : __t) +
'</div>\n    <div class="badge-count"></div>\n</div>\n<div class="alternatives-items"></div>\n';

}
return __p
};});

